var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    ref: "simpleTextPopup",
    attrs: {
      title: _vm.title,
      hideLftBtn: "",
      hideRgtBtn: "",
      large: "",
      scrollToBottom: ""
    },
    on: { popupClose: _vm.closeChatRoom },
    scopedSlots: _vm._u(
      [
        {
          key: "input",
          fn: function() {
            return [
              _c(
                "v-container",
                {
                  staticStyle: { "min-height": "0" },
                  attrs: { fluid: "", "grid-list-lg": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _vm.$slots.issue
                        ? _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [_vm._t("issue")],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.displayComments, function(item, index) {
                        return _c(
                          "v-flex",
                          { key: "item" + index, attrs: { xs12: "" } },
                          [
                            _c(
                              "v-card",
                              {
                                class: _vm.getChatClass(item),
                                attrs: { hover: "", raised: "" }
                              },
                              [
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "cardTitle" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            class:
                                              item.userKey === _vm.userKey
                                                ? "chatroom_card_self"
                                                : ""
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.dateForm(item.createTime)
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        index ===
                                          _vm.displayComments.length - 1 &&
                                        item.userKey === _vm.uid &&
                                        !_vm.readOnly &&
                                        item.createTime &&
                                        (!_vm.createTime ||
                                          (!item.initialComment &&
                                            _vm.createTime <= item.createTime))
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "delete_icon",
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.deleteComment(
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      color: "lighten-2"
                                                    }
                                                  },
                                                  [_vm._v("delete")]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "cardText" }, [
                                      item.isResolution
                                        ? _c(
                                            "span",
                                            { staticStyle: { color: "blue" } },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("resolution")) +
                                                  ": "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(_vm._s(item.content))
                                    ]),
                                    _vm._v(" "),
                                    item.type === "file"
                                      ? _c(
                                          "v-layout",
                                          { attrs: { row: "", wrap: "" } },
                                          [
                                            item.file
                                              ? _c("FsFileChip", {
                                                  key: "file" + index,
                                                  staticClass: "ma-2",
                                                  attrs: {
                                                    file: item.file,
                                                    width: "100%",
                                                    "aspect-ratio": "1.7"
                                                  }
                                                })
                                              : _vm._l(item.files, function(
                                                  file
                                                ) {
                                                  return _c("FsFileChip", {
                                                    key: file.name,
                                                    staticClass: "ma-2",
                                                    attrs: {
                                                      file: file,
                                                      width: "100%",
                                                      "aspect-ratio": "1.7"
                                                    }
                                                  })
                                                })
                                          ],
                                          2
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        },
        {
          key: "popupAction",
          fn: function() {
            return [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  !_vm.readOnly
                    ? _c(
                        "v-flex",
                        { attrs: { xs12: "", "mx-2": "" } },
                        [
                          _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("messageQuantity") +
                                        ": " +
                                        _vm.displayComments.length +
                                        "/" +
                                        _vm.maxMsgQty
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-textarea", {
                            attrs: {
                              outline: "",
                              label: _vm.name,
                              hint: _vm.$t("ctrlEnterToSend"),
                              counter: _vm.maxTextQty,
                              "auto-grow": "",
                              rows: "3"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                if (!$event.ctrlKey) {
                                  return null
                                }
                                $event.stopPropagation()
                                return _vm.submitComment.apply(null, arguments)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                _vm.isCommentWithFile
                                  ? {
                                      key: "append",
                                      fn: function() {
                                        return [
                                          _vm.uploadedFiles.length <= 3
                                            ? _vm._l(
                                                _vm.uploadedFiles,
                                                function(file) {
                                                  return _c(
                                                    "v-chip",
                                                    {
                                                      key: file.name,
                                                      attrs: {
                                                        value:
                                                          _vm.isCommentWithFile,
                                                        close: ""
                                                      },
                                                      on: {
                                                        input: function(v) {
                                                          return (
                                                            !v &&
                                                            _vm.removeSingleUploadFile(
                                                              file
                                                            )
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                " +
                                                          _vm._s(file.name) +
                                                          "\n              "
                                                      )
                                                    ]
                                                  )
                                                }
                                              )
                                            : [
                                                _c(
                                                  "v-menu",
                                                  { attrs: { "offset-y": "" } },
                                                  [
                                                    _c(
                                                      "v-chip",
                                                      {
                                                        attrs: {
                                                          slot: "activator"
                                                        },
                                                        slot: "activator"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "attachments"
                                                            )
                                                          ) +
                                                            ": " +
                                                            _vm._s(
                                                              _vm.uploadedFiles
                                                                .length
                                                            )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-list",
                                                      _vm._l(
                                                        _vm.uploadedFiles,
                                                        function(file) {
                                                          return _c(
                                                            "v-list-tile",
                                                            { key: file.name },
                                                            [
                                                              _c(
                                                                "v-layout",
                                                                {
                                                                  attrs: {
                                                                    row: "",
                                                                    "justify-space-around":
                                                                      "",
                                                                    "align-baseline":
                                                                      ""
                                                                  }
                                                                },
                                                                [
                                                                  _c("v-flex", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        file.name
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-flex",
                                                                    {
                                                                      attrs: {
                                                                        "text-xs-right":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          attrs: {
                                                                            small:
                                                                              "",
                                                                            flat:
                                                                              "",
                                                                            color:
                                                                              "primary",
                                                                            icon:
                                                                              ""
                                                                          },
                                                                          on: {
                                                                            click: function(
                                                                              $event
                                                                            ) {
                                                                              return _vm.removeSingleUploadFile(
                                                                                file
                                                                              )
                                                                            }
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            [
                                                                              _vm._v(
                                                                                "close"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                        ]
                                      },
                                      proxy: true
                                    }
                                  : null
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.content,
                              callback: function($$v) {
                                _vm.content = $$v
                              },
                              expression: "content"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", "mx-2": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "", "justify-end": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs7: "", "text-xs-left": "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary", flat: "" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.$refs.simpleTextPopup.firstMethod()
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("close")))]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.$slots.operation
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs10: "" } },
                                        [_vm._t("operation")],
                                        2
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              !_vm.readOnly && _vm.lastReadTime
                                ? _c("v-checkbox", {
                                    staticStyle: { "margin-top": "0" },
                                    attrs: { label: _vm.$t("markUnread") },
                                    model: {
                                      value: _vm.markAsUnread,
                                      callback: function($$v) {
                                        _vm.markAsUnread = $$v
                                      },
                                      expression: "markAsUnread"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "", "text-xs-right": "" } },
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs8: "", "text-xs-right": "" } },
                                    [
                                      _vm.enableFileUpload && !_vm.readOnly
                                        ? _c("UploadFileWidget", {
                                            ref: "fileUploader",
                                            attrs: {
                                              type: "comments",
                                              maxFiles: 10,
                                              clearFiles:
                                                _vm.uploadedFilesClear,
                                              sizeLimit: _vm.customSizeLimit,
                                              icon: "",
                                              isUseCameraUpload: ""
                                            },
                                            model: {
                                              value: _vm.uploadedFiles,
                                              callback: function($$v) {
                                                _vm.uploadedFiles = $$v
                                              },
                                              expression: "uploadedFiles"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            small: "",
                                            color: "primary",
                                            disabled:
                                              _vm.hasNoContent || _vm.isSending,
                                            loading: _vm.isSending
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.submitComment.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("send")))]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    ),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56c7db03", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c7db03","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatRoom.vue
// module id = null
// module chunks = 